<template>
  <div id="OOPVR">
    <Header />
    <!--页眉信息-->

    <!-- <LoginPage v-if="signIn" @getLoginSignIn="getSignIn" @getRegister="getRegister"></LoginPage> -->
    <!-- :signInShow="signIn" -->

    <!-- <RegisterPage v-if="register" @getRegister="getRegister" @getLoginSignIn="getSignIn"></RegisterPage> -->

    <!-- <tool /> -->
    <!--工具信息-->

    <section>
      <!-- <div> -->
      <!--内容信息-->
      <transition mode="out-in">
        <router-view />
      </transition>
      <!-- </div> -->
    </section>

    <!-- <MessageHint></MessageHint> -->
    <!--信息提示-->

    <Footer />
    <!--页脚信息-->
  </div>
</template>

<script>
import Header from "./index/Header";
import Footer from "./index/Footer";
import Tool from "./index/Tool";
import MessageHint from "./components/tips/messageHint";
// import LoginPage from "./components/column/netuser/LoginPage";
// import RegisterPage from "./components/column/netuser/RegisterPage";

export default {
  name: "OOPVR",
  data() {
    return {
      // signIn: false, //等待登录组件触发事件
      // register: false,
      message: {
        pojo: "未完善",
      },
    };
  },
  components: {
    Header: Header,
    Footer: Footer,
    Tool: Tool,
    MessageHint: MessageHint,
    // LoginPage: LoginPage,
    // RegisterPage: RegisterPage
  },
  created() {},
  mounted() {
    //  this.init();
    // this.$store.dispatch("getRouterData")
  },
  methods: {
    // getAllTreeList(list) {
    //   list.map((item) => {
    //     if (item.hasOwnProperty("children") && item.children.length > 0) {
    //       this.getAllTreeList(item.children);
    //     }
    //     item.scopedSlots = { title: "sortName" };
    //     return item;
    //   });
    //   return list;
    // },
    // init() {
    //   this.$get("/net/client/sort/select/")
    //     .then((response) => {
    //       if (response.code != 1) {
    //         this.$message.error("服务器繁忙", 5);
    //       }
    //       this.$store.state.index.routerData = this.getAllTreeList(response.data);
    //       console.log(this.$store.state.index.routerData)
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    // getSignIn(boolean) {
    //   //把这个事件传递给登录按钮,同时传递给登录组件  传递方式 @getLoginSignIn="getSignIn"
    //   if (boolean > 0) {
    //     //传递过来的
    //     this.signIn = true;
    //   } else if (boolean == 0) {
    //     this.signIn = false;
    //   }
    // },
    // getRegister(boolean) {
    //   if (boolean > 0) {
    //     this.register = true;
    //   } else {
    //     this.register = false;
    //   }
    // },
    // bodyOverflow() {
    //   console.log("123");
    // }
  },
  watch: {
    // signIn() {
    //   console.log(this.register);
    //   console.log(this.signIn);
    //   if (this.register != this.signIn) {
    //     document.body.style.overflow = "hidden";
    //   }else if(this.signIn){
    //     document.body.style.overflow = "hidden";
    //   }else if(this.register == this.signIn){
    //     document.body.style.overflow = "";
    //   }
    // },
    // register(){
    //   if(this.register){
    //     document.body.style.overflow = "hidden";
    //   }else if(this.register == this.signIn){
    //     document.body.style.overflow = "";
    //   }
    // }
  },
};
</script>

<style lang="less" >
@import (css)
  "https://fonts.googleapis.com/css2?family=Kalam:wght@300;700&family=Merriweather:wght@900&family=Roboto:wght@900&family=Tienne:wght@900&display=swap";

body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #eeeeee;
  font-family: "Open Sans", sans-serif;
  // background-color: #fac0cb;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: rgb(55, 58, 63);
}
// a:hover {
//   border-bottom: 2px solid rgb(55, 58, 63);
// }
input,
button,
select,
img {
  vertical-align: middle;
  outline: none;
}
ol,
ul {
  list-style: none;
}
span {
  display: inline-block;
}
// .routerstyle{

// }
#OOPVR {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
}

section {
  // display: inline-block;
  padding-top: 50px;
  // min-height: 1800px;
  width: 1250px;
  margin: 0 auto;
}

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

body::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f0fc86;
}
/* scroll轨道背景 */
body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(88, 241, 203, 0.767);
  border-radius: 5px;
  background-color: #ffffff0c;
}

/* 滚动条中能上下移动的小块 */
body::-webkit-scrollbar-thumb {
  border-radius: 5px;
  box-shadow: inset 0 0 5px rgba(118, 201, 202, 0.842);
  background-color: #8febf1;
}

/**修改全局消息样式 */
:global {
  .ant-message {
    // position:fixed;
    top: calc(40% - 200px);
    left: calc(100% - 200px);
  }
}
</style>


// WEBPACK FOOTER //
// src/OOPVR.vue